import { getFetch, putFetch, postFetch, deleteFetch } from '../utils/fetch';
import {
  LOOKUP_ITEM_API,
  LOOKUP_ITEM_DELETEWITHCHECK_API,
  LOOKUP_ITEM_QUANHUYEN_API,
  LOOKUP_ITEM_NGANHNGHE_API,
  LOOKUP_ITEM_KHUCUMCN_API,
  LOOKUP_ITEM_THAMQUYENQLMT_API,
  LOOKUP_ITEM_NGUONNUOC_API,
  LOOKUP_ITEM_HINHTHUCSOHUU_API,
  LOOKUP_ITEM_TYPE_FACILITY_ATTACHMENT_API,
  LOOKUP_ITEM_TYPE_EIA_ATTACHMENT_API,
  LOOKUP_ITEM_MUCDICH_API,
  LOOKUP_ITEM_TINHTRANG_API,
  LOOKUP_ITEM_TINHTRANG_THANHTRA_API,
  LOOKUP_ITEM_SUKIENTUANTHU_API,
  LOOKUP_ITEM_TYPE_INSPECTION_ATTACHMENT_API,
  LOOKUP_ITEM_TYPE_AUDIT_ATTACHMENT_API,
  LOOKUP_ITEM_PERMITTYPE_API,
  LOOKUP_ITEM_TYPE_PERMIT_ATTACHMENT_API,
  LOOKUP_ITEM_EMISSIONTYPE_API,
  LOOKUP_ITEM_GETALL_API,
  LOOKUP_ITEM_UPDATE_CHILDREN_API,
  LOOKUP_ITEM_LOAIHOSO_API,
  LOOKUP_ITEM_HOACHAT_API,
  LOOKUP_ITEM_BPTGCTNH_API,
  LOOKUP_ITEM_NGUONTHAI_API,
  LOOKUP_ITEM_NGUONTHAI_2_API,
  LOOKUP_ITEM_LIST_API,
  LOOKUP_ITEM_TYPE_BIODIVERSITY_ATTACHMENT_API,
  LOOKUP_ITEM_DEVICE_STAGE_API,
  LOOKUP_ITEM_TYPE_DEVICE_ATTACHMENT_API,
} from './config';

export function getAllLookupItems(ProvinceID = 2) {
  return getFetch(`${LOOKUP_ITEM_API()}/getAll`, {
    ProvinceID,
  });
}

export function getLookupSuKienTuanThu() {
  return getFetch(`${LOOKUP_ITEM_SUKIENTUANTHU_API()}`, {
    ProvinceID: 2,
  });
}
export function getLookupTinhTrangKiemTra() {
  return getFetch(`${LOOKUP_ITEM_LIST_API(38)}`, {
    ProvinceID: 2,
  });
}
export function getLookupTinhTrangThanhTra() {
  return getFetch(`${LOOKUP_ITEM_TINHTRANG_THANHTRA_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupTinhTrang() {
  return getFetch(`${LOOKUP_ITEM_TINHTRANG_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupMucDich() {
  return getFetch(`${LOOKUP_ITEM_MUCDICH_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupKhuCumCN() {
  return getFetch(`${LOOKUP_ITEM_KHUCUMCN_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupThamQuyenQLMT() {
  return getFetch(`${LOOKUP_ITEM_THAMQUYENQLMT_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupQuanHuyen() {
  return getFetch(`${LOOKUP_ITEM_QUANHUYEN_API()}`, {
    ProvinceID: 2,
  });
}

export function getAllLookupQuanHuyen() {
  return getFetch(`${LOOKUP_ITEM_QUANHUYEN_API()}`, {
    // ProvinceID: 2
  });
}

export function getLookupNganhNghe(params = {}) {
  return getFetch(`${LOOKUP_ITEM_NGANHNGHE_API()}`, {
    ProvinceID: 2,
    ...params,
  });
}

export function getAllLookupNganhNghe() {
  return getFetch(`${LOOKUP_ITEM_NGANHNGHE_API()}`, {
    // ProvinceID: 2
  });
}

export function getLookupHinhThucSoHuu() {
  return getFetch(`${LOOKUP_ITEM_HINHTHUCSOHUU_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupNguonNuoc() {
  return getFetch(`${LOOKUP_ITEM_NGUONNUOC_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupTypeFacilityAttachment() {
  return getFetch(`${LOOKUP_ITEM_TYPE_FACILITY_ATTACHMENT_API()}`, {
    ProvinceID: 2,
  });
}
export function getLookupTypeInspectionAttachment() {
  return getFetch(`${LOOKUP_ITEM_TYPE_INSPECTION_ATTACHMENT_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupTypeLegalDocumentAttachment() {
  return getFetch(`${LOOKUP_ITEM_LIST_API(37)}`, {
    ProvinceID: 2,
  });
}
export function getLookupTypeEnvironmentProtectionWorkAttachment() {
  return getFetch(`${LOOKUP_ITEM_LIST_API('LoaiFileDinhKem')}`, {
    ProvinceID: 2,
  });
}

export function getLookupTypeAuditAttachment() {
  return getFetch(`${LOOKUP_ITEM_TYPE_AUDIT_ATTACHMENT_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupTypeEiaAttachment() {
  return getFetch(`${LOOKUP_ITEM_TYPE_EIA_ATTACHMENT_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupPermitType() {
  return getFetch(`${LOOKUP_ITEM_PERMITTYPE_API()}`, {
    ProvinceID: 2,
    itemPerPage: 20,
  });
}

export function getLookupDeviceStage() {
  return getFetch(`${LOOKUP_ITEM_DEVICE_STAGE_API()}`, {
    ProvinceID: 2,
    itemPerPage: 20,
  });
}

export function getLookupTypeDeviceAttachment() {
  return getFetch(`${LOOKUP_ITEM_TYPE_DEVICE_ATTACHMENT_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupTypePermitAttachment() {
  return getFetch(`${LOOKUP_ITEM_TYPE_PERMIT_ATTACHMENT_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupBiodiversityAttachment() {
  return getFetch(`${LOOKUP_ITEM_TYPE_BIODIVERSITY_ATTACHMENT_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupEmissionType() {
  return getFetch(`${LOOKUP_ITEM_EMISSIONTYPE_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupById(_id) {
  return getFetch(`${LOOKUP_ITEM_GETALL_API()}`, {
    lookuplist: _id,
    ProvinceID: 2,
  });
}

export function updateOne(_id, data = {}) {
  return putFetch(`${LOOKUP_ITEM_API()}/${_id}`, data);
}

export function updateChildren(_id, { key, name }) {
  return putFetch(`${LOOKUP_ITEM_UPDATE_CHILDREN_API()}/${_id}`, { key, name });
}

export function create(obj) {
  return postFetch(`${LOOKUP_ITEM_API()}`, {
    ...obj,
    ProvinceID: 2,
  });
}

export function deleteOne(_id) {
  return deleteFetch(`${LOOKUP_ITEM_API()}/${_id}`);
}

export function deleteOneWithCheck(_id, data = {}) {
  return deleteFetch(`${LOOKUP_ITEM_DELETEWITHCHECK_API()}/${_id}`, data);
}

export function deleteOneWithCheckChemistry(_id, data = {}) {
  return deleteFetch(`${LOOKUP_ITEM_API()}/chemistry/${_id}`, data);
}

export function getAll() {
  return getFetch(`${LOOKUP_ITEM_GETALL_API()}`, {
    ProvinceID: 2,
  });
}

export function getAllLookupLoaiHoSo() {
  return getFetch(`${LOOKUP_ITEM_LOAIHOSO_API()}`, {
    ProvinceID: 2,
  });
}

export function getAllLookupHoaChat() {
  return getFetch(`${LOOKUP_ITEM_HOACHAT_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupBPCTNH() {
  return getFetch(`${LOOKUP_ITEM_BPTGCTNH_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupNguonThai1() {
  return getFetch(`${LOOKUP_ITEM_NGUONTHAI_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupNguonThai2() {
  return getFetch(`${LOOKUP_ITEM_NGUONTHAI_2_API()}`, {
    ProvinceID: 2,
  });
}

export function getLookupItem(lookupListId) {
  return getFetch(`${LOOKUP_ITEM_LIST_API(lookupListId)}`, {
    ProvinceID: 2,
  });
}

const slugs = {
  lookuplist: 'lookuplist',
};

const routes = {
  getCategoryById: (LookupListItemID) =>
    [LOOKUP_ITEM_API(), slugs.lookuplist, LookupListItemID].join('/'),
};

export const lookupListItemApi = {
  getCategory: (LookupListItemID, param) => {
    return getFetch(routes.getCategoryById(LookupListItemID), param);
  },
};



// WEBPACK FOOTER //
// ./src/api/lookuplistitemApi.js